module.exports = __webpack_public_path__ + "static/logo-small-211ebacb7a0bf0a46b97fa06d6dfb595.png";